import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  IconButton,
  Select,
  MenuItem,
  InputLabel,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';

import { makeStyles } from '@material-ui/core/styles';
import { useForm, Controller } from 'react-hook-form';
import { format } from 'date-fns';

import { createEntry } from '../../utils/api';

import { firestore } from '../../utils/firebase';

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
  },
  dialogClose: {
    marginRight: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(4),
  },
  formField: {
    marginBottom: theme.spacing(4),
  },
  timeEntry: {
    display: 'flex',
  },
}));

const NewEntry = ({ onClose, open, userId, firstName, lastName, email }) => {
  const { register, handleSubmit, errors, control } = useForm();
  const classes = useStyles();

  const today = format(new Date(), 'yyyy-MM-dd');

  const handleEntrySubmit = (data) => {
    const allData = { firstName, lastName, email, ...data };
    createEntry(userId, allData).then(onClose);
  };

  const [events, setEvents] = useState([]);

  useEffect(() => {
    firestore
      .collection('events')
      .get()
      .then((snapshot) => {
        const events = snapshot.docs.map((d) => d.data().eventName);
        setEvents(events);
      });
  }, []);

  return (
    <Dialog
      onClose={onClose}
      open={open}
      fullWidth={true}
      maxWidth="sm"
      disableBackdropClick={true}
    >
      <div className={classes.dialogTitle}>
        <DialogTitle className={classes.dialogTitle}>
          New Time Entry
        </DialogTitle>
        <IconButton className={classes.dialogClose} onClick={onClose}>
          <CloseIcon style={{ color: '#fff' }} />
        </IconButton>
      </div>
      <DialogContent>
        <form
          noValidate
          id="new-event-form"
          onSubmit={handleSubmit(handleEntrySubmit)}
          className={classes.form}
        >
          {/* <TextField
            error={!!errors.event}
            helperText={!!errors.event && 'Please enter an event name.'}
            inputRef={register({ required: true })}
            name="event"
            label="Event Name"
            className={classes.formField}
          /> */}
          <InputLabel id="event-label">Event Name</InputLabel>
          <Controller
            as={
              <Select
                labelId="event-label"
                label="Event Name"
                className={classes.formField}
              >
                {events.map((e) => (
                  <MenuItem key={e} value={e}>
                    {e}
                  </MenuItem>
                ))}
              </Select>
            }
            name="event"
            error={!!errors.event}
            rules={{ required: 'this is required' }}
            control={control}
            defaultValue=""
          />
          <TextField
            error={!!errors.date}
            helperText={!!errors.date && 'Please enter the event date.'}
            inputRef={register({ required: true })}
            id="date"
            label="Date"
            type="date"
            name="date"
            defaultValue={today}
            className={classes.formField}
          />
          <div className={classes.timeEntry}>
            <TextField
              error={!!errors.start}
              helperText={
                !!errors.start && 'Please enter the event start time.'
              }
              inputRef={register({ required: true })}
              type="time"
              name="start"
              label="Start Time"
              id="start"
              InputLabelProps={{
                shrink: true,
              }}
              style={{ width: '50%' }}
            />
            <TextField
              error={!!errors.end}
              helperText={!!errors.end && 'Please enter the event end time.'}
              inputRef={register({ required: true })}
              type="time"
              name="end"
              label="End Time"
              id="end"
              style={{ width: '50%', marginLeft: '16px' }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <Button className={classes.dialogClose} onClick={onClose}>
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          form="new-event-form"
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

NewEntry.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  userId: PropTypes.string.isRequired,
};

export default NewEntry;
